import { memo } from 'react';

import { useWebsocketManagement } from './hooks/useWebsocketManagement';
import { WebsocketProviderProps } from './types/WebsocketProviderProps';
import { WebsocketContext } from './WebsocketContext';

const WebsocketProviderComponent = ({ children }: WebsocketProviderProps) => {
  const websocketManagement = useWebsocketManagement();

  return (
    <WebsocketContext.Provider value={websocketManagement}>
      {children}
    </WebsocketContext.Provider>
  );
};

export const WebsocketProvider = memo(WebsocketProviderComponent);
